module.exports = __webpack_public_path__ + "img/likeSetting.62fc6afa.svg";